import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mb-4" }
const _hoisted_4 = { class: "row row-image" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_PageLinkPicker = _resolveComponent("PageLinkPicker")!
  const _component_ImageRoundingDetail = _resolveComponent("ImageRoundingDetail")!
  const _component_ImageContainerDimensionsDetail = _resolveComponent("ImageContainerDimensionsDetail")!
  const _component_ImagePositioningDetail = _resolveComponent("ImagePositioningDetail")!
  const _component_ImageOverlaysDetail = _resolveComponent("ImageOverlaysDetail")!
  const _component_ExtraMetadataSection = _resolveComponent("ExtraMetadataSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !_ctx.isReady
    }, null, 8, ["spin"]),
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_InputImage, {
                    modelValue: _ctx.existingDocumentKey,
                    typeCode: _ctx.docType,
                    module: _ctx.DpModuleEnum.CMS,
                    onImageCleared: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setImageKey(null))),
                    "onUpdate:modelValue": _ctx.setImageKey
                  }, null, 8, ["modelValue", "typeCode", "module", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_input_text, {
                        modelValue: _ctx.contentBlock.image.title.nl,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentBlock.image.title.nl) = $event)),
                          _ctx.onChange
                        ],
                        label: _ctx.$t('title'),
                        name: "image_title",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.image.border_type_code,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.image.border_type_code) = $event)),
                          _ctx.onChange
                        ],
                        options: _ctx.enumBorderTypeCode,
                        label: _ctx.$t('cms.borderType'),
                        name: "border_type",
                        selectText: _ctx.$t('selectText'),
                        rules: "required",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.contentBlock.image.border_type_code && _ctx.contentBlock.image.border_type_code !== 'NONE')
                        ? (_openBlock(), _createBlock(_component_InputSelect, {
                            key: 0,
                            modelValue: _ctx.contentBlock.image.border_width_code,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.image.border_width_code) = $event)),
                              _ctx.onChange
                            ],
                            options: _ctx.enumBorderWidthCode,
                            label: _ctx.$t('cms.borderWidth'),
                            name: "border_width",
                            selectText: _ctx.$t('selectText'),
                            errors: _ctx.errors
                          }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.image.lightbox_layout_code,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentBlock.image.lightbox_layout_code) = $event)),
                          _ctx.onChange
                        ],
                        options: _ctx.enumLightboxLayoutCode,
                        label: _ctx.$t('cms.lightboxLayout'),
                        name: "lightbox_layout_code",
                        selectText: _ctx.$t('selectText'),
                        rules: "required",
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.image.horizontal_image_shift_code,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentBlock.image.horizontal_image_shift_code) = $event)),
                          _ctx.onChange
                        ],
                        options: _ctx.enumHorizontalImageShift,
                        label: _ctx.$t('cms.horizontalShift'),
                        name: "horizontal_image_shift_code",
                        selectText: _ctx.$t('selectText'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_InputSelect, {
                        modelValue: _ctx.contentBlock.image.vertical_image_shift_code,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contentBlock.image.vertical_image_shift_code) = $event)),
                          _ctx.onChange
                        ],
                        options: _ctx.enumVerticalImageShift,
                        label: _ctx.$t('cms.verticalShift'),
                        name: "vertical_image_shift_code",
                        selectText: _ctx.$t('selectText'),
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_PageLinkPicker, {
                        payload: _ctx.pageLinkPayload,
                        errors: _ctx.errors,
                        onChanged: _ctx.onPageLinkPickerChanged
                      }, null, 8, ["payload", "errors", "onChanged"])
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_ExtraMetadataSection, {
                id: _ctx.metadataSectionId,
                activeLabels: _ctx.activeMetadataLabels,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_ImageRoundingDetail, {
                    key: `rounding_${_ctx.metadataRevision}`,
                    modelValue: _ctx.contentBlock.image.rounding,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contentBlock.image.rounding) = $event)),
                      _ctx.onChange
                    ],
                    name: _ctx.$t('cms.imageRounding'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])),
                  (_openBlock(), _createBlock(_component_ImageContainerDimensionsDetail, {
                    key: `container_dimensions_${_ctx.metadataRevision}`,
                    modelValue: _ctx.contentBlock.image.container_dimensions,
                    "onUpdate:modelValue": [
                      _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentBlock.image.container_dimensions) = $event)),
                      _ctx.onChange
                    ],
                    name: _ctx.$t('cms.imageContainer'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])),
                  (_openBlock(), _createBlock(_component_ImagePositioningDetail, {
                    key: `positioning_${_ctx.metadataRevision}`,
                    modelValue: _ctx.contentBlock.image.positioning,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contentBlock.image.positioning) = $event)),
                      _ctx.onChange
                    ],
                    name: _ctx.$t('cms.imagePositioning'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])),
                  (_openBlock(), _createBlock(_component_ImageOverlaysDetail, {
                    key: `overlays_${_ctx.metadataRevision}`,
                    modelValue: _ctx.contentBlock.image.overlays,
                    "onUpdate:modelValue": [
                      _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contentBlock.image.overlays) = $event)),
                      _ctx.onChange
                    ],
                    name: _ctx.$t('cms.overlays'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"]))
                ]),
                _: 1
              }, 8, ["id", "activeLabels"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}